import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">

      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/455d4b17bb0830d9dc0ba5f28e276371/62f6a1775c28e8fae1d7823a2bff19b6.png"
          alt="Polokwane South Africa cityscape"
          className="w-full h-full object-cover object-center sm:object-center object-[60%_center]"
        />
        {/* Subtle dark overlay only — no purple */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Hero Content */}
      <div
        className={`relative z-10 w-full flex flex-col items-center justify-center text-center px-6 md:px-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
        style={{ paddingTop: '140px', paddingBottom: '100px' }}
      >
        {/* Eyebrow label */}
        <p
          className="text-xs sm:text-sm text-white/70 uppercase tracking-[0.25em] mb-5"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 500 }}
        >
          Polokwane · Limpopo · South Africa
        </p>

        {/* Main headline */}
        <h1
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-5 leading-tight"
          style={{
            fontFamily: "'Inter', sans-serif",
            fontWeight: 600,
            letterSpacing: '0.01em',
          }}
        >
          Your Protector in Law
        </h1>

        {/* Divider line */}
        <div className="w-12 h-px bg-white/50 mb-6"></div>

        {/* Subheading */}
        <p
          className="text-sm sm:text-base md:text-lg text-white/80 mb-10 leading-relaxed max-w-xl mx-auto"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 400 }}
        >
          Protecting individuals, families, and corporations across Limpopo and beyond.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <button
            onClick={() => navigate('/contact')}
            className="px-8 py-3.5 bg-white text-black font-semibold text-sm tracking-wide uppercase hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '0.08em' }}
          >
            Book a Consultation
          </button>
          <button
            onClick={() => navigate('/our-services')}
            className="px-8 py-3.5 border border-white/70 text-white font-semibold text-sm tracking-wide uppercase hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '0.08em' }}
          >
            Explore Our Services
          </button>
        </div>
      </div>

    </section>
  );
}
